import { render, staticRenderFns } from "./PersonnelTicketDetails.vue?vue&type=template&id=e5406400&scoped=true"
import script from "./PersonnelTicketDetails.vue?vue&type=script&lang=js"
export * from "./PersonnelTicketDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5406400",
  null
  
)

export default component.exports